export const GET_COUPON_WALLET_LIST = 'GET_COUPON_WALLET_LIST';

export const GET_COUPON_WALLET_LIST_SUCCESS = 'GET_COUPON_WALLET_LIST_SUCCESS';

export const GET_COUPON_WALLET_LIST_FAILED = 'GET_COUPON_WALLET_LIST_FAILED';
